'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'sailboat';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e445';
var svgPathData = ['M21.1 400l4 14.3C38.7 462.6 82.8 496 133 496L443 496c50.2 0 94.2-33.4 107.8-81.7l4-14.3L21.1 400zm65-64L208 336l0-203.1L86.1 336zM272 33l0 303 216.5 0L272 33z', 'M270.5 3.3c-2-2.8-5.6-4-9-3S256 4.5 256 8l0 336c0 4.4 3.6 8 8 8l240 0c3 0 5.7-1.7 7.1-4.3s1.1-5.9-.6-8.3l-240-336zM272 336l0-303L488.5 336 272 336zM218.1 96.3c-3.5-1-7.1 .5-9 3.6l-144 240c-1.5 2.5-1.5 5.5-.1 8.1s4.1 4.1 7 4.1l144 0c4.4 0 8-3.6 8-8l0-240c0-3.6-2.4-6.8-5.9-7.7zM86.1 336L208 132.9 208 336 86.1 336zm468.7 64l-4 14.3C537.3 462.6 493.2 496 443 496L133 496c-50.2 0-94.2-33.4-107.8-81.7l-4-14.3 533.8 0zM21.1 384c-10.6 0-18.3 10.1-15.4 20.3l4 14.3C25.3 473.9 75.6 512 133 512L443 512c57.3 0 107.7-38.1 123.2-93.3l4-14.3c2.9-10.2-4.8-20.3-15.4-20.3L21.1 384z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSailboat = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;